import React from 'react';
import { FormControl, Grid2 as Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';

const BillingIntervalInput = ({ formData, onChange, disabled = false }) => {
  return (
    <>
      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 1.5 }}>
        <TextField
          type="number"
          label="Billing Frequency"
          placeholder={'Enter Billing Period'}
          value={formData.billing_interval?.value}
          onChange={(e) =>
            onChange({
              ...formData,
              billing_interval: {
                ...formData.billing_interval,
                value: parseInt(e.target.value, 10),
              },
            })
          }
          size="small"
          fullWidth
          disabled={disabled}
          required
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 1.5 }}>
        <FormControl required fullWidth>
          <InputLabel shrink disabled={disabled}>
            Unit
          </InputLabel>
          <Select
            label="Unit"
            value={formData.billing_interval?.unit || ''}
            onChange={(e) =>
              onChange({
                ...formData,
                billing_interval: {
                  ...formData.billing_interval,
                  unit: e.target.value,
                },
              })
            }
            defaultValue={'month'}
            size="small"
            disabled={disabled}
          >
            <MenuItem value={'day'}>Daily</MenuItem>
            <MenuItem value={'week'}>Weekly</MenuItem>
            <MenuItem value={'month'}>Monthly</MenuItem>
            <MenuItem value={'year'}>Yearly</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 1.5 }}>
        <TextField
          label="Recurrence Limit"
          type="number"
          placeholder={'∞'}
          value={formData.recurrence_limit || ''}
          onChange={(e) => onChange({ ...formData, recurrence_limit: parseInt(e.target.value) })}
          size="small"
          fullWidth
          disabled={disabled}
          slotProps={{
            input: {
              endAdornment: <InputAdornment position="end">Cycles</InputAdornment>,
            },
            inputLabel: {
              shrink: true,
              disabled: disabled,
            },
          }}
        />
      </Grid>
    </>
  );
};

export default BillingIntervalInput;
